import React, { useContext } from "react";
import { QuestionSection, Radio } from "../../components/utility/quote";
import { navigate } from "gatsby-link";

import NavigationContext from "../../contexts/navigationContext";

import Fuel from "../../svgs/navigation/Fuel";
import Saftey from "../../svgs/navigation/Safety";
import Track from "../../svgs/navigation/Track";
import Other from "../../svgs/navigation/Other";

const Next = "/navigation/Questions/4";
const Points = [
  {
    question: "What features do you require?",
    progress: "65%",
    options: [
      {
        answer: "Tracking",
        to: Next,
        icon: <Track />,
      },
      { answer: "Safety management", to: Next, icon: <Saftey /> },
      { answer: "Fuel efficiency", to: Next, icon: <Fuel /> },
      { answer: "Other", to: Next, icon: <Other /> },
    ],
  },
];
export default function Question3({ title }) {
  const { que3, setQue3 } = useContext(NavigationContext);

  return Points.map((item) => {
    return (
      <QuestionSection
        title={title}
        question={item.question}
        progress={item.progress}
      >
        {item.options.map((items) => {
          return (
            <Radio
              key={items.answer}
              icon={items.icon}
              value={items.answer}
              title={items.answer}
              isSelected={que3 === items.answer}
              onChange={(e) => {
                setQue3(e.target.value);
                navigate(items.to);
              }}
            />
          );
        })}
      </QuestionSection>
    );
  });
}
